"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Portal = _interopRequireDefault(require("react-portal/lib/Portal"));

var _reactMotion = require("react-motion");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Mortal =
/*#__PURE__*/
function (_Component) {
  _inherits(Mortal, _Component);

  _createClass(Mortal, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var isOpened = props.isOpened;
      var isPortalOpened = state.isPortalOpened,
          isVisible = state.isVisible;
      var willOpen = !isPortalOpened && isOpened;

      if (willOpen) {
        return {
          isPortalOpened: true,
          isAnimated: true
        };
      }

      var willClose = isPortalOpened && !isOpened;

      if (willClose) {
        return {
          isVisible: false,
          isAnimated: true
        };
      }

      var hasReopened = willOpen && !isVisible && isPortalOpened;

      if (hasReopened) {
        return {
          isVisible: true,
          isAnimated: true
        };
      }

      return null;
    }
  }]);

  function Mortal(props) {
    var _this;

    _classCallCheck(this, Mortal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Mortal).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleKey", function (e) {
      var _this$props = _this.props,
          closeOnEsc = _this$props.closeOnEsc,
          onClose = _this$props.onClose;
      var isPortalOpened = _this.state.isPortalOpened; // handle ESC key

      if (e.which === 27 && isPortalOpened && closeOnEsc) {
        onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleRest", function () {
      if (!_this.state.isVisible) {
        _this.setState({
          isPortalOpened: false,
          isAnimated: false
        });

        _this.props.onHide();
      } else {
        _this.setState({
          isAnimated: false
        });
      }
    });

    _this.state = {
      isPortalOpened: props.isOpened,
      isVisible: props.isOpened,
      isAnimated: false
    };
    return _this;
  }

  _createClass(Mortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keydown', this.handleKey);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var didOpen = this.props.isOpened && !prevProps.isOpened;

      if (didOpen) {
        window.requestAnimationFrame(function () {
          if (_this2._unmounted) {
            return;
          }

          _this2.setState({
            isVisible: true
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.handleKey);
      this._unmounted = true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          motionStyle = _this$props2.motionStyle,
          children = _this$props2.children,
          portalProps = _this$props2.portalProps;
      var _this$state = this.state,
          isPortalOpened = _this$state.isPortalOpened,
          isVisible = _this$state.isVisible,
          isAnimated = _this$state.isAnimated;

      if (!isPortalOpened) {
        return null;
      }

      return _react.default.createElement(_Portal.default, portalProps, _react.default.createElement(_reactMotion.Motion, {
        onRest: this.handleRest,
        style: motionStyle(_reactMotion.spring, isVisible)
      }, function (motion) {
        return children(motion, isVisible, isAnimated);
      }));
    }
  }]);

  return Mortal;
}(_react.Component);

_defineProperty(Mortal, "propTypes", {
  onClose: _propTypes.default.func.isRequired,
  onHide: _propTypes.default.func,
  portalProps: _propTypes.default.object,
  closeOnEsc: _propTypes.default.bool
});

_defineProperty(Mortal, "defaultProps", {
  closeOnEsc: true,
  onHide: function onHide() {
    return null;
  }
});

var _default = Mortal;
exports.default = _default;